<template>
  <Navbar title="Delete vehicle" />
  <div class="confirm-vehicle-box">
    <div class="confirm-vehicle">
      <div class="vehicle-desc w-100%">
        <span class="mr10">{{ vehicleInfo.year }}</span>
        <span class="mr10">{{ vehicleInfo.make }}</span>
        <span class="mr10">{{ vehicleInfo.model }}</span>
      </div>
      <div v-if="vehicleInfo.type === 1" class="vehicle-info">
        <div class="vehicle-item">
          <span class="mr10">{{ vehicleInfo.trim }}</span>
          <span class="mr10">{{ vehicleInfo.engine }}</span>
        </div>
      </div>
      <div v-if="vehicleInfo.type === 2" class="vehicle-info">
        <div class="vehicle-item">
          <span class="mr10">{{ vehicleInfo.submodel }}</span>
        </div>
      </div>
    </div>
    <div class="car-img">
      <van-image width="50%" :src="vehicleInfo.image" />
    </div>
    <div class="desc-agree">
      <div class="text-left">
        <van-icon name="info" class="info-icon mr5" />
        <span>{{ $t('message.garage.vehicleWillDelete') }}</span>
      </div>
      <van-button class="mt20" type="primary" size="large" @click="handleDelete">
        {{ $t('message.confirm') }}
      </van-button>
      <van-button class="mt20" plain type="primary" size="large" @click="handleCancel">
        {{ $t('message.cancel') }}
      </van-button>
    </div>
  </div>
</template>
<script setup>
import Navbar from '@/components/navbar/navbar.vue'
import { useRouter } from 'vue-router'
import { useGarageStore } from '@/store/garage'

const router = useRouter()
const garageStore = useGarageStore()
const vehicleInfo = computed(() => {
  if (garageStore.selectedCar.vpid) {
    return garageStore.selectedCar
  } else {
    return garageStore.favoriteCar
  }
})

const handleDelete = async () => {
  const res = await garageStore.doDeleteMyCar(vehicleInfo.value)
  if (res?.success) {
    await garageStore.getGarageCarList({})
    router.back()
  }
}
const handleCancel = () => {
  window.parent.postMessage({ type: 'close', action: '', dataStr: '' }, '*')
}

onMounted(() => {
  const { carList, getGarageCarList } = garageStore
  if (!carList.length) {
    getGarageCarList({})
  }
})

// const confirmVehicle = async () => {
//   await garageStore.doAddMyCar()
//   router.push('/garage')
// }

// const goBack = () => {
//   router.replace('/garage')
// }

// const toSelectType = () => {
//   router.replace('/vehiceltype')
// }
</script>
<style lang="scss" scoped>
.confirm-vehicle {
  padding: 0 10px;
  .vehicle-desc {
    font-size: 18px;
    color: #111;
    font-weight: bold;
  }
  .vehicle-info {
    font-size: 16px;
    color: #666;
  }
}
.car-img {
  padding: 10px 20px;
  text-align: center;
}
.info-icon {
  color: #fdbb2b;
}
.confirm-vehicle-box {
  padding: 10px;
  .desc-agree {
    font-size: 14px;
    color: #666;
    text-align: center;
    padding: 0 10px;
  }
}
</style>
